import React from 'react';
import styled from 'styled-components';
import Hero from './section/hero/Hero';
import ShopByCategory from './section/ShopByCategory/ShopByCategory';
import NewArrivals from './section/NewArrivals/NewArrivals';
import FeaturedCollections from './section/FeaturedCollections/FeaturedCollections';
import BestSellers from './section/BestSellers/BestSellers';
import StayInStyle from './section/StayInStyle/StayInStyle';
import Instagram from './section/Instagram/Instagram';
import DesignerFavorites from './section/DesignerFavorites/DesignerFavorites';
import ShopTheLook from './ShopTheLook/ShopTheLook';

function Home() {
  return (
    <Wrapper>
      <Hero />
      <ShopByCategory />
      <NewArrivals />
      <DesignerFavorites />
      <FeaturedCollections />
      <BestSellers />
      <ShopTheLook />
      <StayInStyle />
      {/*<Instagram />*/}
    </Wrapper>
  );
}

const Wrapper = styled.div``;

export default React.memo(Home);
